import React from 'react'
import { FilterAlt } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import SvgIcon from 'Pods/Shared/SvgIcon'

function FiltersIcon() {
  return (
    <SvgIcon>
      <FilterAlt width="24" height="24" />
    </SvgIcon>
  )
}

export default FiltersIcon
